import React from 'react';
import { freeBetStore } from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import { marketsStore } from '../../../../store';

const Markets = observer(() => {
  const { markets, currentClickedMarket } = marketsStore;
  const { activeFreeBet } = freeBetStore;
  return (
    <>
      {markets?.length ? (
        markets.map((item) => {
          const { from, to, odd, market } = item;
          return (
            <div
              className={`coef-item-el ${
                activeFreeBet?.id && activeFreeBet?.minOdd > odd ? 'passive' : ''
              } ${currentClickedMarket === market ? 'active' : ''}`}
              onClick={() => {
                // marketsStore.updateIsDisabledMarketBetButton(false);
                marketsStore.setCurrentClickedMarket(market);
                marketsStore.changeMarketBetData(item);
              }}
              key={market}
            >
              <span className='coef-item-suit'>x{odd}</span>
              <div className='coef-item-value'>
                <span>{from !== to ? `${from}-${to}` : from}</span>
              </div>
            </div>
          );
        })
      ) : (
        <></>
      )}
    </>
  );
});

export default Markets;
